// extracted by mini-css-extract-plugin
module.exports = {"yj-font-style":"yj-font-style--1PGHW","yjBreadcrumbWrapper":"yjBreadcrumbWrapper--xQXUy","yjBreadcrumb":"yjBreadcrumb--3rEI8"};